import React, { useEffect, useState } from "react";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { TextField } from "@mui/material";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import config from '../../../../utils/config';


const Step1 = (props) => {
  const {
    firstName,
    lastName,
    dateNaissance,
    setError,
    adresse,
    ville,
    villeResidence,
    setVilleResidence,
    arrondissementResidence,
    setArrondissementResidence,
    quartierResidence,
    setQuartierResidence,
    sexe,
    setSexe,
    setFirstName,
    setLastName,
    setDateNaissance,
    setAdresse,
    setVille,
    setShowBtn,
    telephone1,
    setTelephone1,
    telephone2,
    setTelephone2,
  } = props;

  const [msgFirstName, setMsgFirstName] = useState("");
  const [msgLastName, setMsgLastName] = useState("");
  const [msgTelephone1, setMsgTelephone1] = useState("");
  const [msgTelephone2, setMsgTelephone2] = useState("");
  const [msgDateNaissance, setMsgDateNaissance] = useState("");
  const [msgAdresse, setMsgAdresse] = useState("");
  const [msgVille, setMsgVille] = useState("");
  const [msgVilleResidence, setMsgVilleResidence] = useState("");
  const [msgArrondissementResidence, setMsgArrondissementResidence] = useState("");
  const [msgQuartierResidence, setMsgQuartierResidence] = useState("");
  const [msgSexe, setMsgSexe] = useState("");

  const [quartiersStructure, setQuartiersStructure] = useState(null);

  const handleSelect = async (selected) => {
    setAdresse(selected);
    try {
      const results = await geocodeByAddress(selected);
      const latLng = await getLatLng(results[0]);
      console.log('Latitude et longitude:', latLng);
    } catch (error) {
      console.error('Erreur de géocodage:', error);
    }
  };

  useEffect(() => {
    let formatTelephone = /^(06|05|04)[0-9]{7}$/;
    let annee = dateNaissance ? new Date(dateNaissance).getFullYear() : 0;
    const currentYear = new Date().getFullYear();
    const ageMin = currentYear - 80; // 18 ans -> annee <= currentYear - 18
    const ageMax = currentYear - 18;  // 80 ans -> annee >= currentYear - 80
    const ageOk = annee >= ageMin && annee <= ageMax;

    if (
      firstName !== "" &&
      lastName !== "" &&
      dateNaissance !== "" &&
      ville !== "" &&
      villeResidence !== "" &&
      arrondissementResidence !== "" &&
      quartierResidence !== "" &&
      adresse !== "" &&
      telephone1 !== "" &&
      formatTelephone.test(telephone1) &&
      (formatTelephone.test(telephone2) || telephone2 === "") &&
      sexe !== "" &&
      ageOk
    ) {
      setShowBtn(true);
    } else {
      setShowBtn(false);
    }
    // eslint-disable-next-line
  }, [firstName, lastName, dateNaissance, adresse, ville, villeResidence, arrondissementResidence, quartierResidence, sexe, telephone1, telephone2]);

  useEffect(() => {
    if (ville === "") {
      setMsgVille("Le département est obligatoire");
    } else {
      setMsgVille("");
    }
  }, [ville]);

  useEffect(() => {
    if (villeResidence === "") {
      setMsgVilleResidence("La ville de résidence est obligatoire");
    } else {
      setMsgVilleResidence("");
    }
  }, [villeResidence]);

  useEffect(() => {
    if (arrondissementResidence === "") {
      setMsgArrondissementResidence("L'arrondissement de résidence est obligatoire");
    } else {
      setMsgArrondissementResidence("");
    }
  }, [arrondissementResidence]);

  useEffect(() => {
    if (quartierResidence === "") {
      setMsgQuartierResidence("Le quartier de résidence est obligatoire");
    } else {
      setMsgQuartierResidence("");
    }
  }, [quartierResidence]);

  useEffect(() => {
    const v = (ville || "").trim();
    if (!v) {
      setQuartiersStructure(null);
      return;
    }
    const url = `${config.apiUrl}/comptes/quartiers/structure/?ville=${encodeURIComponent(v)}`;
    fetch(url)
      .then((r) => r.json())
      .then((data) => setQuartiersStructure(data?.structure || null))
      .catch(() => setQuartiersStructure(null));
  }, [ville]);

  useEffect(() => {
    if (firstName === "") {
      setMsgFirstName("Le prenom est obligatoire");
    } else {
      setMsgFirstName("");
    }
  }, [firstName]);

  useEffect(() => {
    if (sexe === "") {
      setMsgSexe("Le sexe est obligatoire");
    } else {
      setMsgSexe("");
    }
  }, [sexe]);

  useEffect(() => {
    if (lastName === "") {
      setMsgLastName("Le nom est obligatoire");
    } else {
      setMsgLastName("");
    }
  }, [lastName]);

  useEffect(() => {
    if (dateNaissance === "") {
      setMsgDateNaissance("La date de naissance est obligatoire");
    } else {
      const currentYear = new Date().getFullYear();
      const annee = new Date(dateNaissance).getFullYear();
      if (annee >= currentYear - 80 && annee <= currentYear - 18) {
        setMsgDateNaissance("");
      } else {
        setMsgDateNaissance("L'âge doit être compris entre 18 et 80 ans");
      }
    }
  }, [dateNaissance]);

  useEffect(() => {
    if (adresse === "") {
      setMsgAdresse("L'adresse est obligatoire");
    } else {
      setMsgAdresse("");
    }
  }, [adresse]);

  useEffect(() => {
    if (telephone1 === "") {
      setMsgTelephone1("Le premier numero de tel est obligatoire");
    } else {
      let formatTelephone = /^(06|05|04)[0-9]{7}$/;
      if (formatTelephone.test(telephone1)) {
          setMsgTelephone1("");
      } else {
          setMsgTelephone1("Le format du numéro de téléphone est invalide");
      }
    }
  }, [telephone1]);

  useEffect(() => {
    setError("")
    if (telephone1 === telephone2) {
      setMsgTelephone2("Les deux numéros ne doivent pas être identiques");
    } else {
      let formatTelephone = /^(06|05|04)[0-9]{7}$/;
      if(telephone2 !== ""){
        if (formatTelephone.test(telephone2)) {
            setMsgTelephone2("");
        } else {
            setMsgTelephone2("Le format du numéro de téléphone est invalide");
        }
      }else{
        setMsgTelephone2("");
      }
    }
  }, [telephone1, telephone2, setError]);

  useEffect(() => {
    setMsgFirstName("");
    setMsgSexe("");
    setMsgLastName("");
    setMsgAdresse("");
    setMsgVille("");
    setMsgVilleResidence("");
    setMsgArrondissementResidence("");
    setMsgQuartierResidence("");
    setMsgDateNaissance("");
    setMsgTelephone1("");
    setMsgTelephone2("");
  }, []);

  const handleVille = (e) => {
    const next = e.target.value;
    setVille(next);
    setVilleResidence('');
    setArrondissementResidence('');
    setQuartierResidence('');
  };

  const handleVilleResidence = (e) => {
    setVilleResidence(e.target.value);
    setArrondissementResidence('');
    setQuartierResidence('');
  };

  const handleArrondissementResidence = (e) => {
    setArrondissementResidence(e.target.value);
    setQuartierResidence('');
  };


  const handleChange = (e) => {
    setAdresse(e);
  };

  const selectedCity = quartiersStructure?.villes?.find((c) => c.ville === villeResidence);
  const selectedArrondissement = selectedCity?.arrondissements?.find(
    (a) => a.arrondissement === arrondissementResidence
  );
  const quartiers = selectedArrondissement?.quartiers || [];

  return (
    <div className="row mt-5">
      <TextField
        type="text"
        name="firstName"
        label="Prénom(s)"
        className="w-100"
        value={firstName}
        onChange={e => {
          setFirstName(e.target.value)
        }}
        placeholder="Ex : Mondésir"
        variant="outlined"
        required
        error={Boolean(msgFirstName)}
        helperText={msgFirstName}
        style={{marginBottom: '20px'}}
      />
      <TextField
        type="text"
        name="lastName"
        label="Nom(s)"
        className="w-100"
        value={lastName}
        onChange={e => {
          setLastName(e.target.value)
        }}
        placeholder="Ex : NTSOUMOU"
        variant="outlined"
        required
        error={Boolean(msgLastName)}
        helperText={msgLastName}
        style={{marginBottom: '20px'}}
      />
      <p>Date de naissance</p>
      <TextField
        type="date"
        name="date"
        className="w-100"
        value={dateNaissance}
        onChange={e => {
          setDateNaissance(e.target.value)
        }}
        variant="outlined"
        required
        error={Boolean(msgDateNaissance)}
        helperText={msgDateNaissance}
        style={{marginBottom: '20px'}}
      />

      <FormControl sx={{ width: '100%' }}>
        <InputLabel id="demo-simple-select-label">Votre sexe</InputLabel>
        <Select
          className="select w-100"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={sexe}
          label="Votre sexe"
          onChange={e => setSexe(e.target.value)}
        >
          <MenuItem value="Masculin">Masculin</MenuItem>
          <MenuItem value="Feminin">Feminin</MenuItem>
        </Select>
        <p style={{ color: "red",textAlign: 'center' }}>{msgSexe}</p>
      </FormControl>
      <FormControl sx={{ width: '100%' }}>
        <InputLabel id="demo-simple-select-label">Votre Département</InputLabel>
        <Select
          className="select"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={ville}
          label="Votre Département"
          onChange={handleVille}
        >
          <MenuItem value="Brazzaville">Brazzaville</MenuItem>
          <MenuItem value="Pointe_Noire">Pointe Noire</MenuItem>
        </Select>
        <p style={{ color: "red" }}>{msgVille}</p>
      </FormControl>

      {quartiersStructure?.villes?.length > 0 && (
        <>
          <FormControl sx={{ width: '100%', mt: 2 }}>
            <InputLabel id="ville-residence-label">Ville de résidence</InputLabel>
            <Select
              className="select"
              labelId="ville-residence-label"
              id="ville-residence-select"
              value={villeResidence}
              label="Ville de résidence"
              onChange={handleVilleResidence}
            >
              {quartiersStructure.villes.map((c) => (
                <MenuItem key={c.ville} value={c.ville}>
                  {c.ville}
                </MenuItem>
              ))}
            </Select>
            <p style={{ color: "red" }}>{msgVilleResidence}</p>
          </FormControl>

          {selectedCity?.arrondissements?.length > 0 && (
            <FormControl sx={{ width: '100%', mt: 2 }}>
              <InputLabel id="arrondissement-residence-label">Arrondissement de résidence</InputLabel>
              <Select
                className="select"
                labelId="arrondissement-residence-label"
                id="arrondissement-residence-select"
                value={arrondissementResidence}
                label="Arrondissement de résidence"
                onChange={handleArrondissementResidence}
              >
                {selectedCity.arrondissements.map((a) => (
                  <MenuItem key={a.arrondissement} value={a.arrondissement}>
                    {a.arrondissement}
                  </MenuItem>
                ))}
              </Select>
              <p style={{ color: "red" }}>{msgArrondissementResidence}</p>
            </FormControl>
          )}

          {quartiers.length > 0 && (
            <FormControl sx={{ width: '100%', mt: 2 }}>
              <InputLabel id="quartier-residence-label">Quartier de résidence</InputLabel>
              <Select
                className="select"
                labelId="quartier-residence-label"
                id="quartier-residence-select"
                value={quartierResidence}
                label="Quartier de résidence"
                onChange={(e) => setQuartierResidence(e.target.value)}
              >
                {quartiers.map((q) => (
                  <MenuItem key={q} value={q}>
                    {q}
                  </MenuItem>
                ))}
              </Select>
              <p style={{ color: "red" }}>{msgQuartierResidence}</p>
            </FormControl>
          )}
        </>
      )}

      <FormControl sx={{ width: '100%' }}>
      <PlacesAutocomplete
        value={adresse}
        onChange={handleChange}
        onSelect={handleSelect}
        searchOptions={{
          componentRestrictions: { country: 'CG' }, // 'CG' est le code ISO 3166-1 alpha-2 pour la République du Congo
          types: ['address'] // Limite les résultats aux adresses
        }}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <TextField
              type="text"
              name="adresse"
              label="Adresse complète"
              className="w-100"
              {...getInputProps({
                placeholder: "Ex : 46 Rue Missakou, MOUKONDO",
                variant: "outlined",
                required: true,
                error: Boolean(msgAdresse),
                helperText: msgAdresse,
                style: { marginBottom: '20px' }
              })}
            />
            <div>
              {loading && <div>Chargement...</div>}
              {suggestions.map(suggestion => {
                const style = {
                  backgroundColor: suggestion.active ? "#41b6e6" : "#fff"
                };
                return (
                  <div {...getSuggestionItemProps(suggestion, { style })}>
                    {suggestion.description}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
      </FormControl>
      <TextField
        type="text"
        name="telephone1"
        label="Premier numéro de téléphone"
        className="w-100"
        value={telephone1}
        onChange={e => {
          setTelephone1(e.target.value)
        }}
        placeholder="Format : 064723424"
        variant="outlined"
        required
        error={Boolean(msgTelephone1)}
        helperText={msgTelephone1}
        style={{marginBottom: '20px'}}
      />

      <TextField
        type="text"
        name="telephone2"
        label="Deuxième numéro de téléphone (optionnel)"
        className="w-100"
        value={telephone2}
        onChange={e => {
          setTelephone2(e.target.value)
        }}
        placeholder="Format : 055652586"
        variant="outlined"
        error={Boolean(msgTelephone2)}
        helperText={msgTelephone2}
        style={{marginBottom: '20px'}}
      />

    </div>
  );
};

export default Step1;
